<template>
  <div class="search-bar">
    <div v-show="!show" class="search-placeholder" @click="inputEvent">
      <img src="../assets/search.png" alt="" class="search-icon">
      {{ placeholder }}
    </div>
    <input
      v-show="show"
      type="text"
      ref="input"
      :placeholder="placeholder"
      @keyup.enter="EnterFn"
    />
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      typeof: String,
      default: "搜索线路、课程",
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    EnterFn(e){
      this.$emit('enter',e.target.value)
    },
    inputEvent() {
      this.show = !this.show;
      this.$nextTick(()=> {
          this.$refs.input.focus();
      })
    },
    blurEvent() {
      this.show = !this.show;
    },
  },
};
</script>

<style scoped lang="scss">
.search-bar {
  width: 100%;
  height: 100%;
  min-height: 8vw;
  position: relative;
  font-size: 3.733vw;
  color: #c4c4c4;
  .search-icon{
    width: 2.4vw;
    height: 2.667vw;
    margin-right: 2vw;
  }
  .search-placeholder {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  input {
    width: 100%;
    height: 100%;
    min-height: 8vw;
    margin: 0;
    padding: 2.667vw;
    box-sizing: border-box;
    background: none;
    border: none;
    user-select: none;
    outline: none;
    
  }
}
</style>